import { Link } from "gatsby";
import PropTypes from "prop-types";
import React from "react";

const Header = ({ siteTitle }) => (
  <header className="header-container">
    <Link to="/">
      <svg xmlns="http://www.w3.org/2000/svg" height="25" viewBox="0 0 506 331">
        <title>Go to the home page</title>
        <g fill="none" fillRule="evenodd">
          <circle cx="165.5" cy="165.5" r="165.5" fill="#EF3085" />
          <circle cx="340.5" cy="165.5" r="165.5" fill="#34B6DD" />
          <path
            fill="#42458A"
            d="M253,25.2187885 C299.847155,54.5054142 331,106.481298 331,165.718784 C331,224.95627 299.847155,276.932153 253,306.218779 C206.152852,276.932164 175,224.956276 175,165.718784 C175,106.481291 206.152852,54.5054029 253.000015,25.2187789 Z"
          />
        </g>
      </svg>
    </Link>
    <div>
      <a href="https://twitter.com/lorvsso">Twitter</a>
      <a href="https://github.com/lorvsso">GitHub</a>
      <a href="https://www.linkedin.com/in/jacklorusso/">LinkedIn</a>
    </div>
  </header>
);

Header.propTypes = {
  siteTitle: PropTypes.string,
};

Header.defaultProps = {
  siteTitle: ``,
};

export default Header;
